export class ThreeDKeys {
  public static readonly THREEJS_OBJECTS_LABEL_NAME = '3D_Label';
  public static readonly SCENE = 'Scene';
}
